{
  "GENERAL": {
    "SHOWING_RESULTS": "نمایش {firstIndex} تا {lastIndex} از {totalCount} مورد",
    "PHONE_INPUT": {
      "PLACEHOLDER": "جستجو",
      "EMPTY_STATE": "نتیجه‌ای یافت نشد"
    },
    "CLOSE": "بستن",
    "BETA": "آزمایشی",
    "BETA_DESCRIPTION": "This feature is in beta and may change as we improve it.",
    "ACCEPT": "Accept",
    "DISCARD": "Discard",
    "PREFERRED": "Preferred"
  },
  "CHOICE_TOGGLE": {
    "YES": "بله",
    "NO": "خیر"
  }
}
